import React from 'react';
import { Clock3, Play } from 'lucide-react';

const durationLabel = (seconds) => {
  if (!seconds) return 'Video lesson';
  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  return `${minutes}:${String(remainder).padStart(2, '0')}`;
};

export const TrainingMediaCard = ({ item, selected, assetUrl, onSelect }) => (
  <button
    type="button"
    onClick={() => onSelect(item)}
    className={`group overflow-hidden rounded-md border text-left transition-[border-color,background-color,transform] hover:-translate-y-0.5 ${selected ? 'border-[#d6b562] bg-[#263228]' : 'border-white/15 bg-[#18211b] hover:border-[#d6b562]/70'}`}
    data-testid={`training-media-card-${item.id}`}
  >
    <span className="relative block aspect-video overflow-hidden bg-black">
      <img src={item.poster_url ? assetUrl(item.poster_url) : '/assets/welcome-video-poster.webp'} alt="" className="h-full w-full object-cover object-center opacity-85 transition-[opacity,transform] group-hover:scale-[1.02] group-hover:opacity-100" data-testid={`training-media-poster-${item.id}`} />
      <span className="absolute inset-0 grid place-items-center bg-black/15"><span className="grid h-11 w-11 place-items-center rounded-full border border-[#f2d78d] bg-black/55 text-[#f2d78d]"><Play className="ml-0.5 h-5 w-5" /></span></span>
    </span>
    <span className="block p-4">
      <span className="block text-base font-semibold text-[#fff9e8]" data-testid={`training-media-title-${item.id}`}>{item.title}</span>
      <span className="mt-1 line-clamp-2 block min-h-10 text-sm leading-5 text-[#b7c5bb]" data-testid={`training-media-description-${item.id}`}>{item.description || 'A Crown & Rose training lesson.'}</span>
      <span className="mt-3 flex items-center justify-between gap-2 text-xs text-[#91a097]"><span className="truncate">{item.audience}</span><span className="inline-flex shrink-0 items-center gap-1"><Clock3 className="h-3.5 w-3.5" /> {durationLabel(item.duration_seconds)}</span></span>
    </span>
  </button>
);